<script setup>
const props = defineProps({
  active: {
    type: Boolean,
    required: false,
    default: true,
  },
})
</script>

<template>
  <svg
    width="17"
    height="18"
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.0928 17.9707C12.5405 17.9707 12.0928 17.523 12.0928 16.9707L12.0928 10.67C12.0928 10.1177 12.5405 9.66998 13.0928 9.66998C13.6451 9.66998 14.0928 10.1177 14.0928 10.67L14.0928 16.9707C14.0928 17.523 13.6451 17.9707 13.0928 17.9707Z"
      :fill="props.active ? 'white' : 'black'"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.40039 8.85937C2.84811 8.85937 2.40039 8.41166 2.40039 7.85938L2.40039 1.55866C2.40039 1.00637 2.84811 0.558657 3.40039 0.558657C3.95267 0.558657 4.40039 1.00637 4.40039 1.55866L4.40039 7.85937C4.40039 8.41166 3.95268 8.85937 3.40039 8.85937Z"
      :fill="props.active ? 'white' : 'black'"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.34625 18C1.49156 18 -6.61201e-08 16.4873 -1.47008e-07 14.6369C-2.27895e-07 12.7864 1.49156 11.2737 3.34625 11.2737C5.20094 11.2737 6.69251 12.7864 6.69251 14.6369C6.69251 16.4873 5.20094 18 3.34625 18ZM2 14.6369C2 15.3963 2.60963 16 3.34625 16C4.08287 16 4.69251 15.3963 4.69251 14.6369C4.69251 13.8774 4.08287 13.2737 3.34625 13.2737C2.60963 13.2737 2 13.8774 2 14.6369Z"
      :fill="props.active ? 'white' : 'black'"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.0538 6.72656C11.1989 6.72656 9.70752 5.21369 9.70752 3.3626C9.70752 1.51166 11.1995 0.000274593 13.0538 0.000274512C14.908 0.000274431 16.4 1.51166 16.4 3.3626C16.4 5.21369 14.9087 6.72656 13.0538 6.72656ZM11.7075 3.3626C11.7075 4.12312 12.3174 4.72656 13.0538 4.72656C13.7902 4.72656 14.4 4.12312 14.4 3.3626C14.4 2.60358 13.7908 2.00027 13.0538 2.00027C12.3167 2.00027 11.7075 2.60358 11.7075 3.3626Z"
      :fill="props.active ? 'white' : 'black'"
    />
  </svg>
</template>
